/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderOrderMode = "LIMIT_ORDER" | "MARKET_ORDER" | "%future added value";
export type OrderOrderType = "BUY" | "SELL" | "%future added value";
export type PortfolioPastTransactionQueryVariables = {|
  searchPolitician?: ?string,
  first?: ?number,
|};
export type PortfolioPastTransactionQueryResponse = {|
  +pastTransactionOrderWise: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +stock: {|
          +id: string,
          +name: string,
          +price: number,
          +openShare: number,
          +totalShare: number,
          +lockedShares: number,
        |},
        +orderMode: OrderOrderMode,
        +quantity: number,
        +created: any,
        +orderType: OrderOrderType,
        +pastTransactionOrderWiseAvgPrice: ?number,
      |}
    |}>
  |}
|};
export type PortfolioPastTransactionQuery = {|
  variables: PortfolioPastTransactionQueryVariables,
  response: PortfolioPastTransactionQueryResponse,
|};
*/


/*
query PortfolioPastTransactionQuery(
  $searchPolitician: String
  $first: Int
) {
  pastTransactionOrderWise(searchPolitician: $searchPolitician, first: $first) {
    edges {
      node {
        stock {
          id
          name
          price
          openShare
          totalShare
          lockedShares
        }
        orderMode
        quantity
        created
        orderType
        pastTransactionOrderWiseAvgPrice
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchPolitician"
},
v2 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "searchPolitician",
    "variableName": "searchPolitician"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PoliticiansNode",
  "kind": "LinkedField",
  "name": "stock",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openShare",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalShare",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockedShares",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderMode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pastTransactionOrderWiseAvgPrice",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PortfolioPastTransactionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "OrderNodeConnection",
        "kind": "LinkedField",
        "name": "pastTransactionOrderWise",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PortfolioPastTransactionQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "OrderNodeConnection",
        "kind": "LinkedField",
        "name": "pastTransactionOrderWise",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrderNodeEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrderNode",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "db83654252290d3d60c78d13e3c67001",
    "id": null,
    "metadata": {},
    "name": "PortfolioPastTransactionQuery",
    "operationKind": "query",
    "text": "query PortfolioPastTransactionQuery(\n  $searchPolitician: String\n  $first: Int\n) {\n  pastTransactionOrderWise(searchPolitician: $searchPolitician, first: $first) {\n    edges {\n      node {\n        stock {\n          id\n          name\n          price\n          openShare\n          totalShare\n          lockedShares\n        }\n        orderMode\n        quantity\n        created\n        orderType\n        pastTransactionOrderWiseAvgPrice\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd34295ee951084be4474c37b4c85da27';

module.exports = node;
